import {request} from './../request.js'
import AppConfig from '../../../config/AppConfig.js'

// 根据客服微信，获取进粉列表数据
export function webGetFanspassList(wxid,lastId,callback){
	request({
		method: 'post',
		url: 'Fanspass/getListIncById',
		data: {
		  wxid: wxid,
		  lastId: lastId
		}
	}).then((response)=>{
		if(response.data.code == 1){
			callback(response.data.data)
		}else{
			callback([])
		}
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 根据客服微信，获取进粉列表总数
export function webGetFanspassCount(wxid,callback){
	request({
		method: 'post',
		url: 'Fanspass/getCount',
		data: {
		  wxid: wxid
		}
	}).then((response)=>{
		if(response.data.code == 1){
			callback(response.data.data.count)
		}else{
			callback(0)
		}
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 根据id，删除数据
export function webDeleteFanspass(id,callback){
	request({
		method: 'post',
		url: 'Fanspass/delete',
		data: {
		  id: id
		}
	}).then((response)=>{
		callback(true)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}